import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { SpaceSettingsProps } from './SpaceSettingsForgeExtensionPortal.tsx';

export const LazySpaceSettingsForgeExtensionPortal: LoadableType<SpaceSettingsProps> =
	LoadableAfterPaint({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-SpaceSettingsForgeExtensionPortal" */ './SpaceSettingsForgeExtensionPortal.tsx'
				)
			).SpaceSettingsForgeExtensionPortal,
	});
LazySpaceSettingsForgeExtensionPortal.displayName = 'LazySpaceSettingsForgeExtensionPortal';
